module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/2e43fd/tc-custom/9781460315361.jpg?1726574237594",
      "alt": "This image is the cover for the book His Brand of Passion, The Bryants: Powerful & Proud"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("His Brand of Passion, The Bryants: Powerful & Proud\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("Money usually solves everything")]), _c('br'), _c('br'), _vm._v("Billionaire Aaron Bryant lives and works on a knife's edge; his dark, brooding persona and fearsome reputation hide a shameful family secret. So sassy maid of honor Zoe Parker is an unwelcome distraction when, at his brother's wedding, she hides Aaron's ever-ringing phone down her tight pink dress!"), _c('br'), _c('br'), _c('i', [_vm._v("But Aaron's never had a problem like this before!")]), _c('br'), _c('br'), _vm._v("Aaron's arrogant, skilled retrieval of his property sparks a chemistry that ends in a mind-blowing one-night stand. But such uncontrollable passion leaves an indelible mark on their lives. He never expected to see Zoe again, until two little lines appeared on a stick."), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kate Hewitt\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kate Hewitt has worked a variety of different jobs, from drama teacher to editorial assistant to youth worker, but writing romance is the best one yet. She also writes women's fiction and all her stories celebrate the healing and redemptive power of love. Kate lives in a tiny village in the English Cotswolds with her husband, five children, and an overly affectionate Golden Retriever.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0